export default __webpack_public_path__ + "838d78793b0c16f285bea5ec3b063b13.ico";